import { smartHttp } from "@/utils/http/index.js"; // bfsSsoHttp

/**
 * 查询邮件列表
 * @param {object} data
 * https://yapi.ops.yunlizhi.cn/project/697/interface/api/35136
 */
export function getPlanEmailListApi(data, params) {
  return smartHttp.request({
    url: "/planMailManagement/selectMail",
    method: "post",
    data,
    params
  });
}

/**
 * 新增邮件
 * @param {object} data
 * https://yapi.ops.yunlizhi.cn/project/697/interface/api/35118
 */
export function createPlanEmailApi(data) {
  return smartHttp.request({
    url: "/planMailManagement/createMail",
    method: "post",
    data,
  });
}

/**
 * 编辑邮件
 * @param {object} data
 * https://yapi.ops.yunlizhi.cn/project/697/interface/api/35127
 */
export function modifyPlanEmailApi(data) {
  return smartHttp.request({
    url: "/planMailManagement/updateMail",
    method: "post",
    data,
  });
}

/**
 * 查询收件人地址和正文等等
 * @param {object} data
 * https://yapi.ops.yunlizhi.cn/project/697/interface/api/35429
 */
export function getAddresseeAndContentApi(data) {
  return smartHttp.request({
    url: "/planMailManagement/selectRecipient",
    method: "post",
    data,
  });
}


